import {Props as ReportsSpreadsheetColumnProps} from 'modules/reports/components/Spreadsheet/Column'
import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
import useStyles from './ReportsSpreadsheetCell.styles'
import {useReportsSpreadsheetRowContext} from 'modules/reports/components/Spreadsheet/Row/ReportsSpreadsheetRow.context'

type Props = {
  column: ReportsSpreadsheetColumnProps
}

function ReportsSpreadsheetCell(props: Props) {
  const {column} = props
  const {prefix, data} = useReportsSpreadsheetRowContext()
  const classes = useStyles()
  const p = usePrefix(`${prefix}-${column.name}`)
  const value = data[column.name]

  return (
    <td className={classes.root} data-testid={p()}>
      {value}
    </td>
  )
}

export default ReportsSpreadsheetCell
